import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { StringUtils } from '../../utils';
import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, SingleScreenNavBar, Header } from  '../../components'

import '../../css/SingleScreens/PracticeAdminsAddEditScreen.css';

class PracticeAdminsAddEditScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      displayAddAdmin: false,
    }
  }

  renderAdminsAddEditSection = (members) => {

    if (!members) {
      return null;
    }

    const currentlyLoggedInUserId = this.props.user && this.props.user.auth && this.props.user.auth.user_id ? this.props.user.auth.user_id : '';

    const currentAdminRows = members.map((member) => {
      const memberInfo = member.user_details && member.user_details[0] ? member.user_details[0] : { first_name: 'test' };
      if (memberInfo && member.admin === true) {
        return <div key={member._id} className="flex-container flex-container-row flex-space-between" style={{ alignItems: 'center', marginBottom: 5 }}>
          <span style={{ color: 'grey', fontSize: 13 }}>{ StringUtils.displayName(memberInfo) }</span>
          { currentlyLoggedInUserId === member.user_id ? null
          : <input  type="submit"
              value={'Remove ' + StringUtils.sentenceCase(memberInfo.first_name) + ' as Admin'}
              className="button-clear-blue"
              style={{ fontSize: 13 }}
              onClick={ () => {
                const userRoles = {
                  user_id: member.user_id,
                  admin: false,
                  vet: member.vet,
                  practice_manager: member.practice_manager,
                  parctice_owner: member.practice_owner,
                  tech: member.tech,
                  behaviorist: member.behaviorist,
                  practice_id: member.practice_id,
                  _id: member._id,
                }
                this.props.practiceActions.updatePracticeUserRole(this.props.user.auth.token, userRoles, () => { this.setState({ ...this.state, displayAddAdmin: false }) })
              }}
            />
          }
        </div>
      }
    })

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">

        <div className="standard-container">
          <Header title='Current Admins' icon='fas fa-users-cog' />

          <div className='flex-container-column' style={{ padding: 15 }}>
            <div className="flex-container flex-container-column">
              <span>{ currentAdminRows }</span>
            </div>

            <div className="flex-container flex-container-column">
              <div className="flex-container flex-container-row flex-center-justify"  style={{ height: 45 }}>
                { this.state.displayAddAdmin ? null
                :  <input  type="submit"
                      value={'Configure Admins'}
                      style={{ alignSelf: 'center', marginTop: 15, fontSize: 13 }}
                      className="button-default"
                      onClick={ () => { this.setState({ ...this.state, displayAddAdmin: true }) }}
                    />
                }
              </div>
            </div>
          </div>

        </div>

        { this.renderAddAdminInterface() }

      </div>
    </div>
  }

  renderAddAdminInterface = () => {
    const allStaffMembers = this.props.practice.staff || null;

    if (!allStaffMembers || this.state.displayAddAdmin === false) {
      return null;
    }

    const starrRows = allStaffMembers.map((member) => {
      const userDetails = member.user_details && member.user_details[0] ? member.user_details[0] : null;
      if (userDetails && member.admin !== true) {
        return <div key={member._id} className="flex-container flex-container-row flex-space-between" style={{ marginTop: 3, marginBottom: 3, paddingRight: '20%', paddingLeft: '20%' }}>
          <span style={{ fontSize: 13, color: 'grey' }}>{ StringUtils.displayName(userDetails) }</span>
          <input  type="submit"
                  value={'Add'}
                  style={{ fontSize: 13 }}
                  className="button-clear-blue"
                  onClick={ () => {
                    const userRoles = {
                      user_id: member.user_id,
                      admin: true,
                      vet: member.vet,
                      practice_manager: member.practice_manager,
                      parctice_owner: member.practice_owner,
                      tech: member.tech,
                      behaviorist: member.behaviorist,
                      practice_id: member.practice_id,
                      _id: member._id,
                    }
                    this.props.practiceActions.updatePracticeUserRole(this.props.user.auth.token, userRoles, () => { this.setState({ ...this.state, displayAddAdmin: false }) })
                  }}
                />
        </div>
      }
    }).filter((memRow) => { return memRow });

    return <div className="standard-container" style={{ marginBottom: 100 }}>
        <Header title='Add Admin' icon='fas fa-user-plus' />
        <div className='flex-container-column' style={{ padding: 15 }}>
          <div className="flex-container flex-container-column" style={{ marginTop: 15 }}>
            { starrRows }
          </div>
          <div className="flex-container flex-container-row" style={{ justifyContent: 'flex-end' }}>
            <input  type="submit"
                    value={'Cancel'}
                    style={{ alignSelf: 'center', marginTop: 15, fontSize: 13 }}
                    className="button-default"
                    onClick={ () => { this.setState({ ...this.state, displayAddAdmin: false }) }}
                  />

          </div>
        </div>
      </div>
  }

  render() {

    const staffMembers = this.props.practice.staff || null;

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="Practice Admins" />
        { this.renderAdminsAddEditSection(staffMembers) }
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PracticeAdminsAddEditScreen)
